import VisibilityIcon from '@mui/icons-material/Visibility'
import { openInNewTab } from '../../../utils'
import { IconButton } from '@material-ui/core'

export const PreviewButton = ({ url }) => (
  <IconButton>
    <VisibilityIcon
      onClick={() => {
        openInNewTab(url)
      }}
      color="primary"
    />
  </IconButton>
)
